<template>
  <div>
    <div v-if="liensObj.length">
      <div
        v-for="(item, index) in liensObj"
        :key="index"
        class="px-3 baseContentFont border mx-1 mb-3 py-1"
      >
        <div class="row">
          <div class="col" :class="$style.status"
            ><strong>Case Number:</strong>
            {{ formatDisplay(item.caseNumber) }}</div
          >
          <div class="col" :class="$style.status"
            ><strong>Jurisdiction: </strong
            >{{ formatDisplay(item.fillingJuridictionName) }}</div
          >
          <div class="col" :class="$style.status"
            ><strong>Amount:</strong> {{ formatDisplay(item.amount) }}</div
          >
        </div>

        <div class="row">
          <div class="col" :class="$style.status"
            ><strong>IRS Serial:</strong>
            {{ formatDisplay(item.irsSerial) }}</div
          >
          <div class="col" :class="$style.status"
            ><strong> State:</strong> {{ formatDisplay(item.state) }}</div
          >
          <div class="col" :class="$style.status"
            ><strong>Eviction:</strong> {{ formatDisplay(item.eviction) }}</div
          >
        </div>
        <div class="row">
          <div class="col" :class="$style.status"
            ><strong>Release Date:</strong>
            {{ formatDisplay(item.releaseDate) }}</div
          >
          <div class="col" :class="$style.status"
            ><strong>Vacated Date:</strong>
            {{ formatDisplay(item.vacatedDate) }}</div
          >
          <div class="col" :class="$style.status"
            ><strong>Satisfied Date:</strong>
            {{ formatDisplay(item.statisfiedDate) }}</div
          >
        </div>
        <div class="row border-top">
          <div class="col" md="12">
            <BaseELabel label="Filing Records" class="mb-2" new-style />
            <b-table
              :items="fillingItems[index]"
              :fields="filingRecordsFields"
              bordered
              responsive="sm"
              striped
              :class="{
                'mb-0': !fillingItems[index].length,
                fraudReportHeaderTable: true,
              }"
            >
            </b-table>

            <NoRecordFound v-if="!fillingItems[index].length"></NoRecordFound>
          </div>
        </div>
        <div class="row">
          <div class="col" md="12">
            <BaseELabel label="Debtors" class="mb-2" new-style />
            <b-table
              :items="debtorsItems[index]"
              :fields="debtorsFields"
              bordered
              responsive="sm"
              striped
              :class="{
                'mb-0': !debtorsItems[index].length,
                fraudReportHeaderTable: true,
              }"
            >
              <!-- <template v-slot:cell(ssn)="row">
                {{ 'XXX-XX-' + row.item.ssn.substring(7, 11) || noData }}
              </template>
              <template v-slot:cell(companyName)="row">
                {{ row.item.companyName || noData }}
              </template>
              <template v-slot:cell(address)="row">
                {{ row.item.address || noData }}
              </template>
              <template v-slot:cell(taxId)="row">
                {{ row.item.taxId || noData }}
              </template> -->
            </b-table>
            <NoRecordFound v-if="!debtorsItems[index].length"></NoRecordFound>
          </div>
        </div>
        <div class="row">
          <div class="col" md="12">
            <BaseELabel label="Creditors" class="mb-2" new-style />
            <b-table
              :items="creditorItems[index]"
              :fields="creditorFields"
              bordered
              responsive="sm"
              striped
              :class="{
                'mb-0': !creditorItems[index].length,
                fraudReportHeaderTable: true,
              }"
            >
            </b-table>
            <NoRecordFound v-if="!creditorItems[index].length"></NoRecordFound>
          </div>
        </div>
      </div>
    </div>
    <NoRecordFound v-else class="mx-1"></NoRecordFound>
  </div>
</template>

<script>
import NoRecordFound from '@src/components/_norecord-found.vue'
export default {
  components: { NoRecordFound },
  props: {
    liensData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      filingRecordsFields: [
        {
          key: 'fillingNumber',
          label: 'Number',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
        },
        {
          key: 'fillingType',
          label: 'Type',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
        },
        {
          key: 'fillingDate',
          label: 'Filling Date',
          thClass: 'text-right',
          tdClass: 'textTruncatee text-right',
        },
        {
          key: 'agency',
          label: 'Agency',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
        },
        {
          key: 'agencyState',
          label: 'Agency State',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
        },
        {
          key: 'agencyCounty',
          label: 'Agency County',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
        },
      ],
      fillingItems: [],
      debtorsFields: [
        {
          key: 'name',
          label: 'Name',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '350px' },
        },
        {
          key: 'address',
          label: 'Address',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '100%-200px' },
        },
        {
          key: 'ssn',
          label: 'SSN/FEIN',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '150px' },
        },
      ],
      debtorsItems: [],
      creditorFields: [
        {
          key: 'name',
          label: 'Name',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '350px' },
        },
        {
          key: 'address',
          label: 'Address',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '100%-200px' },
        },
        {
          key: 'fein',
          label: 'SSN/FEIN',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '150px' },
        },
      ],
      creditorItems: [],
    }
  },
  computed: {
    liensObj() {
      return this.liensData
    },
  },
  mounted() {
    let tableData = this.liensObj || []

    tableData.map((x) => {
      x.debators = (x.debators || []).filter(
        (obj, index, self) =>
          index ===
          self.findIndex((db) => db.ssn === obj.ssn && db.name === obj.name)
      )
      x.debators.forEach((ele, ind) => {
        if (!Object.values(ele).some((x) => x !== null && x !== '')) {
          x.debators.splice(ind, 1)
        }
      })

      this.debtorsItems.push(
        (x.debators || []).map((d) => {
          return {
            ssn:this.formatssn(d) ,
            name: this.formatName(d),
            address: this.formatDisplay(d.address),
          }
        })
      )
      x.creditors = (x.creditors || []).filter(
        (obj, index, self) =>
          index ===
          self.findIndex(
            (cr) => cr.name === obj.name && cr.address === obj.address
          )
      )

      x.creditors.forEach((ele, ind) => {
        if (!Object.values(ele).some((x) => x !== null && x !== '')) {
          x.creditors.splice(ind, 1)
        }
      })

      this.creditorItems.push(
        (x.creditors || []).map((c) => {
          return {
            name: this.formatName(c) ,
            fein:this.formatssn(c),
            address: this.formatDisplay(c.address),
          }
        })
      )

      x.filingRecords = (x.filingRecords || []).filter(
        (obj, index, self) =>
          index ===
          self.findIndex(
            (t) =>
              t.fillingNumber === obj.fillingNumber &&
              t.fillingType === obj.fillingType &&
              t.fillingDate === obj.fillingDate &&
              t.agency === obj.agency &&
              t.agencyCity === obj.agencyCity &&
              t.agencyState === obj.agencyState &&
              t.agencyCounty === obj.agencyCounty
          )
      )
      this.fillingItems.push(
        (x.filingRecords || []).map((f) => {
          return {
            fillingNumber: this.formatDisplay(f.fillingNumber),
            fillingType: this.formatDisplay(f.fillingType),
            fillingDate: this.formatDisplay(f.fillingDate),
            agency: this.formatDisplay(f.agency),
            agencyState: this.formatDisplay(f.agencyState),
            agencyCounty: this.formatDisplay(f.agencyCounty),
          }
        })
      )
    })
  },
  methods: {
    formatDisplay(value) {
      return value || null
    },

    formatssn(c){
     if(c.ssn && c.fein) return  'xxx-xx-'+c.ssn.substring(7)+'/'+c.fein
     if(c.ssn && !c.fein) return 'xxx-xx-'+c.ssn.substring(7) + '/'
     if(!c.ssn && c.fein) return '/'+ c.fein
    },

    formatName(c){
      if(c.name && c.companyName) return c.name+";"+c.companyName
      if(c.name && !c.companyName) return c.name
      if (!c.name && c.companyName) return c.companyName
      return null
    }
  },
}
</script>

<style lang="scss" module>
@import '@design';

.status {
  font-size: $size-content-font;
  color: $color-text-gray;
}
</style>
